<script>

import { Pie } from 'vue-chartjs'

export default {
  extends: Pie,
  components: {
  },
  props: ['plans'],
  name: 'PlansByProfile',
  data () {
    return {
      options: {
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
          datalabels: {
            display: false
          }
        }
      },
      data: {
        datasets: [{
          data: [ 0, 0, 0 ],
          backgroundColor: ['rgba(52, 152, 219, 0.8)', 'rgba(98, 203, 49, 0.5)', 'rgba(30, 107, 10, 0.8)']
        }],
        labels: []
      }
    }
  },
  methods: {
    draw: function () {
      this.data.datasets[0].data = []
      let planValue = []
      let planLabels = []

      this.plans.forEach((plan) => {
        planLabels.push(plan.name)
        planValue.push(plan.nb)
      })

      this.data.datasets[0].data = planValue
      this.data.labels = planLabels
      this.options.labels = planLabels

      this.renderChart(this.data, this.options)
    }
  },
  mounted () {
    this.draw()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/PlansByProfile.vue